import { useState } from 'react';
import Banner from '@/pages/components/common/Banner'
import List from './components/news/List'
import Tab from './components/news/Tab'
import useFetch from '@/api/useFetch';
import { useTranslation } from 'react-i18next'
const Index = (props) => {
  const { i18n } = useTranslation ()
  const { response = [] } = useFetch('getNews', {
    lang: i18n.language
  })
  const [tab, setTab] = useState(0)
  const NewsType = ['all', 'game', 'company']

  console.log(response)
  return (
    <>
      <Banner />
      <Tab active={tab} onChange={setTab}/>
      <div className="mod">
        <List category={tab} data={tab === 0 ? response : response.filter(i => i.cate === NewsType[tab])}/>
      </div>
    </>
  )
}

export default Index
